import React from 'react'

export const IosSwitch = ({ onChange, checked, scale, disabled = false }) => {
  return (
    <React.Fragment>
      <div
        className={`ios-switch ${disabled ? 'ios-switch-disabled' : null}`}
        style={{ transform: `scale(${scale ? scale : 1.0})` }}
        role="button"
        tabIndex="0"
      >
        <input
          type="checkbox"
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
        <i></i>
      </div>
    </React.Fragment>
  )
}
